var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col space-y-4"},[(_vm.title)?_c('Header',{attrs:{"text":_vm.title,"secondary":""}}):_vm._e(),_vm._l((_vm.options),function(ref){
var label = ref.label;
var id = ref.id;
var value = ref.value;
var outlined = ref.outlined;
var underlined = ref.underlined;
var action = ref.action;
return _c('ButtonElement',{key:id,attrs:{"outlined":outlined,"underline":underlined,"label":label},on:{"click":function($event){return _vm.onButtonClickHandler({ label: label, value: value }, action)}}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }